"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OtpContextProvider: ()=>OtpContextProvider,
    useOtpContext: ()=>useOtpContext
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const OtpContext = /*#__PURE__*/ (0, external_react_namespaceObject.createContext)(void 0);
const OtpContextProvider = ({ handleOtpSubmit, children })=>{
    const [otpFormData, setOtpFormData] = (0, external_react_namespaceObject.useState)();
    const [otpDeliveryType, setOtpDeliveryType] = (0, external_react_namespaceObject.useState)();
    const [otpDeliveryMethodUsed, setOtpDeliveryMethodUsed] = (0, external_react_namespaceObject.useState)();
    const [showOtpVerificationForm, setShowOtpVerificationForm] = (0, external_react_namespaceObject.useState)(false);
    const [verificationApiFunction, setVerificationApiFunction] = (0, external_react_namespaceObject.useState)();
    const [resendInProgress, setResendInProgress] = (0, external_react_namespaceObject.useState)(false);
    const [otpResent, setOtpResent] = (0, external_react_namespaceObject.useState)(false);
    const [otpRequestErrorMsg, setOtpRequestErrorMsg] = (0, external_react_namespaceObject.useState)('');
    const value = {
        otpRequestErrorMsg,
        setOtpRequestErrorMsg,
        otpResent,
        setOtpResent,
        resendInProgress,
        setResendInProgress,
        otpDeliveryType,
        setOtpDeliveryType,
        otpFormData,
        setOtpFormData,
        showOtpVerificationForm,
        setShowOtpVerificationForm,
        verificationApiFunction,
        setVerificationApiFunction,
        handleOtpSubmit,
        otpDeliveryMethodUsed,
        setOtpDeliveryMethodUsed
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OtpContext.Provider, {
        value: value,
        children: children
    });
};
const useOtpContext = ()=>{
    const context = (0, external_react_namespaceObject.useContext)(OtpContext);
    if (!context) throw new Error('useOtpContext must be used within an OtpContextProvider');
    return context;
};
exports.OtpContextProvider = __webpack_exports__.OtpContextProvider;
exports.useOtpContext = __webpack_exports__.useOtpContext;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OtpContextProvider",
    "useOtpContext"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
